import { useMemo } from 'react'
import type { TabMappings } from '../types'

interface TabRefs {
  detailsContainerRef: React.RefObject<HTMLDivElement | null>
  faqContainerRef: React.RefObject<HTMLDivElement | null>
  prizesContainerRef: React.RefObject<HTMLDivElement | null>
}

export const useTabMappings = (refs: TabRefs): TabMappings =>
  useMemo(
    () => ({
      refs: {
        ['GiveawayDetailsTab']: refs.detailsContainerRef,
        ['GiveawayFaqTab']: refs.faqContainerRef,
        ['GiveawayPrizesTab']: refs.prizesContainerRef,
      },
    }),
    [refs.detailsContainerRef, refs.faqContainerRef, refs.prizesContainerRef],
  )
